import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed, when, autorun} from 'mobx';
import {observer, inject} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';
import BaseViewStore from 'base-viewstore';
import BaseContentModel from 'base-contentmodel';

import {Mixin, mix} from 'mixwith';
import {ViewControllerMixin} from 'layout-component';

export class SimgateAuthViewStore extends mix(BaseViewStore).with(ViewControllerMixin){
  constructor(){
    super(...arguments);
    const {
      contentModel, 
      dataModel: {
        domainStore: projectDomainStore
      },
      currentView: {
        route
      },
      modalViewStore
    } = this.props;

    //just in case we're already signed in :-)
    if(!(process && process.env && process.env.mockMode)) projectDomainStore.refreshContext();

    // tempoarary until we actually get this in place
    setTimeout( () => { projectDomainStore.context.simParentPathId = 3 }, 1000 )
    // set up condition for this auth strategy being "done""
    when(
      () => projectDomainStore.context.simParentPathId > 0 //we have user's future team paths' parent path
        && projectDomainStore.context.user.roleID
        && route.roles.some( r => r.roleId === projectDomainStore.context.user.roleID ), //user context reflects they are allowed in to this route
      () => {
        projectDomainStore.signOut = action( () => {
          const dirtyEntities = contentModel.$parent.entities.values().filter( ent => ent.isDirty );
          modalViewStore.setModal({
            title: "Would you like to log out?",
            message: dirtyEntities.length ? "You will lose "+dirtyEntities.length+" unsaved changes." : "",
            confirmLabel: 'Logout',
            confirmBtnClass: 'green check-a',
            cancelLabel: 'Cancel',
            cancelBtnClass: 'red times-b',
            onConfirmFunc: () => projectDomainStore._signOut( () => window.location.reload() )
          })
        } )
        contentModel.done = true
      }
    )



  } 
  @observable.ref role = null
  @observable claim = {
    loginName: "",
    password: "",
    authCode: ""
  }
  @computed get viewMap(){
    return {
      "signup": {
        id: "signup",
        Component: SignUp,
        contentModel: this.props.contentModel
      },
      "chooseSession": {
        id: "chooseSession",
        Component: ChooseSession,
        contentModel: this.props.contentModel
      }
    }
  }
  @computed get invalidSignUp(){
    const invalid = {}
    const {
      contentModel: {
        authCode
      }
    } = this.props;

    if(!this.claim.loginName) invalid.email = "*Please enter email";
    if(!this.claim.password) invalid.password = "*Please enter password";
    // @TODO use encryption to make this worth something
    if(this.claim.authCode !== authCode ) invalid.authCode = "*Invalid auth code";
    return invalid;
  }
  @computed get invalidSignIn(){
    const {dataModel: {domainStore}} = this.props;
    const {
      currentView: {
        route: {
          roles
        }
      },
      contentModel: {
        authCode
      }
    } = this.props;

    const invalid = {}

    if(!this.claim.loginName) invalid.email = "*Please enter email";
    if(!this.claim.password) invalid.password = "*Please enter password";
    if( domainStore.context.user.roleID && !roles.some( r => r.roleId === domainStore.context.user.roleID ) ) 
      invalid.notAuthorized = "Not authorized.";
    return invalid;
  }
  @observable warning = ""
  @action.bound handleSignIn(e){
    e && e.preventDefault && e.preventDefault();
    const {dataModel: {domainStore}} = this.props;
    domainStore.signIn( this.claim, null, err => err && (this.warning = err.message) )
  }
  @action.bound handleSignUp(e){
    e.preventDefault();
    const {
      dataModel: {
        domainStore
      },
      contentModel: {
        allowSignupFor,
        authCode
      }
    } = this.props;

    domainStore.createUser( { 
      roleID: allowSignupFor.roleId, 
      firstName: this.claim.loginName,
      email: this.claim.loginName,
      ...this.claim 
    }, () => this.handleSignIn() )
  }
  @action.bound updateClaim(which, val){
    this.claim[which] = val;
  }
}

@editable
@inject("dataModel")
@inject("modalViewStore")
@observer
@autoclass
export class SignIn extends BaseComponent{
  static ViewStore = SimgateAuthViewStore;
  render(){
    const { 
      dataModel: {
        domainStore
      },
      contentModel: authContentModel
    } = this.props;

    const { 
      title, 
      headerMessage, 
      welcomeMessage,
      allowSignupFor
    } = authContentModel;

    const {
      SelectedView, 
      clearView, 
      selectView, 
      handleSignIn, 
      invalidSignIn: invalid,
      claim,
      updateClaim,
      warning
    } = this.viewStore; 

    if(invalid.notAuthorized){
      return <div>{invalid.notAuthorized}<button onClick={ () => domainStore.signOut( () => window.location.reload() ) }>Reload</button></div>
    }

    if(SelectedView) return (<div>
      <SelectedView viewStore={this.viewStore} />
    </div>)

    //actual sign in view    
    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form data-editable={authContentModel}>
            <div className="role-title">{title}</div>
            <div className="messages">
              {!!headerMessage && <h2 className="header-message">{headerMessage}</h2>}
              {!!welcomeMessage && <div className="welcome-message">{welcomeMessage}</div>}
            </div>
            <div className="inputs">
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span><br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span><br />
		          {!!warning && <h2>{warning}</h2>}
              <div className="sign-in-actions">
                <button disabled={Object.keys(invalid).length} className="btn red sign-in-b" onClick={ handleSignIn }>Sign In</button>
              </div>
            </div>
            {!!allowSignupFor && <div className="sign-up-container">
              <span className="nr-text">Not Registered?</span>
              <span className="nr-link" onClick={e => {e.preventDefault(); selectView("signup", {role: allowSignupFor});} }>Sign Up</span>
            </div>}
          </form>
      </div>
    </div>
    )    
  }
}
export default SignIn;

@editable
@observer
@autoclass
export class SignUp extends BaseComponent{
  render(){
    const {
      contentModel, 
      contentModel: {
        signUpMessage,
        allowSignupFor,
        title
      }, 
      viewStore: {
        handleSignUp, 
        claim, 
        updateClaim, 
        invalidSignUp: invalid,
        clearView
      }
    } = this.props;

    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form /*data-editable={contentModel}*/>
            {!!contentModel.title && <div className="role-title">{contentModel.title}</div>}
            {!!signUpMessage && <div className="messages">
              {!!signUpMessage && <div className="welcome-message">{signUpMessage}</div>}
            </div>}      
            <div className="inputs">
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span><br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span><br />
              <input className="auth-code" type="password" value={claim.authCode} placeholder="Authorization Code" onChange={e => updateClaim("authCode", e.target.value)} />
              <span className="validation-error">{invalid.authCode}</span><br />
              <div className="sign-in-actions">
                <span className="btn red sign-up-b" disabled={!!Object.keys(invalid).length} onClick={handleSignUp}>Sign Up</span>
              </div>
            </div>
            {!!allowSignupFor && <div className="sign-up-container">
              <span className="nr-text">Already Registered?</span>
              <span className="nr-link" onClick={e => clearView()}>Sign In</span>
            </div>}
          </form>
        </div>
      </div>)
  }
}

@editable
@observer
@autoclass
export class ChooseSession extends BaseComponent {
  render() {
    const { contentModel, contentModel: { signUpMessage }, handleSignUp, claim, updateClaim, invalid } = this.props;

    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form data-editable={contentModel}>
            {!!signUpMessage && <div className="messages">
              {!!signUpMessage && <div className="signup-message">{signUpMessage}</div>}
            </div>}
            <div className="inputs">
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span>
              <br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span>
              <br />
              <div className="sign-in-actions">
                <span className="btn red sign-up-b" onClick={handleSignUp}>Sign Up</span>
              </div>
            </div>
          </form>
        </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./app_modules/simgate-auth-strategy/component.js